export const BUCKET_STATIC_URL = `${process.env.NEXT_PUBLIC_CONTENT_ASSETS_URL}/static`;
